import { useEffect, useState } from 'react';

import { GiphyFetch } from '@giphy/js-fetch-api';
import { IGif } from '@giphy/js-types';

const giphyFetch = new GiphyFetch(process.env.GIPHY_API_KEY);

type UseGiphyApi = {
  gif: IGif;
  error: Error;
};

function useGiphy(id: string | null): UseGiphyApi {
  const [gif, setGif] = useState<IGif>();
  const [giphyApiError, setGiphyApiError] = useState<Error>();

  useEffect(() => {
    const fetchGif = async () => {
      try {
        const { data } = await giphyFetch.gif(id);
        setGif(data);
      } catch (error) {
        setGiphyApiError(error);
      }
    };

    if (id) {
      fetchGif();
    }
  }, [id]);

  return {
    gif,
    error: giphyApiError,
  };
}

export default useGiphy;
